module.exports = __webpack_public_path__ + "static/gss-banner-54d23f17063174328a4ca12719079d12.png";